<template>
    <div>
        <Form
            :model="searchItem"
            :label-width="85"
            label-position="left"
            :disabled="loading"
            ref="formValidate" 
            :show-message="false"
            style="margin-top:20px"
        >
            <div class="searchRow">
                <div style="display:flex">
                    <FormItem label="中文描述">
                        <Input v-model="searchItem.chName" clearable/>
                    </FormItem>
                    <Button type="primary" style="margin-left:20px" @click="getData()">查询</Button>
                </div>
                <div class="btnGroup">
                </div>
            </div>
        </Form>
        <Table
              stripe
              border
              :columns="columns"
              :loading="loading"
              :data="dataTable"
            >
            <template slot="slot1" slot-scope="{ row }">
                <Button type="primary" @click="openPop(1,row)">列表配置</Button>
            </template>
            <template slot="slot2" slot-scope="{ row }">
                <Icon
                    @click="openPop(2,row)"
                    type="md-eye"
                    style="font-size: 30px;"
                    color="#8CD29B"
                  ></Icon>
            </template>
            <template slot="slot4" slot-scope="{ row }">
                <Button type="primary" @click="openPop(4,row)">邮件内容可定义变量</Button>
            </template>
            <template slot="delete" slot-scope="{ row }">
                <Button icon="md-create"   type="warning" size="small"  @click="openPop(3,row)">编辑</Button>
                <Button icon="md-trash" type="error" size="small"  @click="opendelete(row)" style="margin-left:20px">删除</Button>
            </template>
        </Table>
        <div style="margin: 15px 0">
          <Page :total="this.totalNum" style="float:left" @on-change="pageChange" />
          <Button type="primary" icon="md-add" style="float:right" @click="addData()">新增</Button>
        </div>
        

        <Modal v-model="addPop" :title="transferType==3?'编辑提醒设置':'新增提醒设置'" :mask-closable="false">
            <Form :model="addItem" :label-width="110" label-position="left" ref="addFormValidate" :rules="ruleValidate">
                <FormItem label="中文描述" prop="chName">
                    <Input v-model="addItem.chName" />
                </FormItem>
                <FormItem label="英文描述" prop="enName">
                    <Input v-model="addItem.enName" />
                </FormItem>
                <FormItem label="员工范围" prop="userOrganizationFlag">
                    <RadioGroup v-model="addItem.userOrganizationFlag">
                        <Radio label="0">
                            <span>组织架构</span>
                        </Radio>
                        <Radio label="1">
                            <span>汇报线</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="bottomBtn" slot="footer">
                <Button type="primary" @click="addCancel()">取消</Button>
                <Button  type="primary" @click="addSaveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>

        <Modal v-model="visualPop" :title="columns[transferType+2].title" :mask-closable="false">
            <TabsTransferComponent v-if="transferType==1||transferType==2" :transferData="transferData" :transferTitle="transferTitle" @transferChange="transferChange"></TabsTransferComponent>
            <Form v-if="transferType==1" :model="whereItem" :label-width="80" label-position="left" :rules="whereRuleValidate" ref="whereFormValidate" style="margin-top:20px">
                <FormItem label="条件" prop="whereValue">
                    <Input v-if="transferType==1" style="width:98%" v-model="whereItem.whereValue" type="textarea" :autosize="true" placeholder="" />
                </FormItem>
            </Form>
            <Form v-if="transferType==4" :model="emailItem" :label-width="160" label-position="left" ref="emailRuleValidate" :rules="emailRuleValidate" >
                <FormItem label="收件人" prop="receivedRoleGroup">
                    <Select v-model="emailItem.receivedRoleGroup">
                        <Option value="0">员工</Option>
                        <Option value="1">主管</Option>
                    </Select>
                </FormItem>
                <FormItem label="抄送" prop="carbonCopyList">
                    <!-- <Button type="primary" @click="roleChangeTransfer()">角色</Button> -->
                    <Select v-model="emailItem.carbonCopyList" multiple >
                        <Option v-for="(item,index) in roleList" :value="item.roleId" :key="index">{{ item.roleName }}</Option>
                    </Select>
                    <!-- <Input search enter-button @on-search="roleChangeTransfer" /> -->
                </FormItem>
                <FormItem label="是否自动触发邮件" prop="beAutoSend">
                    <RadioGroup v-model="emailItem.beAutoSend">
                        <Radio :label="item.value" v-for="(item,index) in SFList" :key="index">
                            <span>{{item.label}}</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="附件（提醒人列表）" prop="beFileSend">
                    <RadioGroup v-model="emailItem.beFileSend">
                        <Radio :label="item.value" v-for="(item,index) in SFList" :key="index">
                            <span>{{item.label}}</span>
                        </Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="主题" prop="mailSubject">
                    <Input v-model="emailItem.mailSubject"/>
                </FormItem>
                <FormItem label="内容" prop="mailContent">
                    <Input v-model="emailItem.mailContent" :rows="4" type="textarea" />
                </FormItem>
            </Form>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="bottomBtn" slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary" @click="saveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
import TabsTransferComponent from './components/TabsTransferComponent'
export default {
    components:{
        TabsTransferComponent
    },
    data(){
        return{
            loading:false,
            spinShow:false,
            searchItem:{
                chName:''
            },
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            columns:[
                {
                    title: '序号',
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '中文描述',
                    key: 'chName',
                    width: 270,
                    align: "center"
                },
                {
                    title: '英文描述',
                    key: 'enName',
                    width: 270,
                    align: "center"
                },
                {
                    title: '提醒名单查询',
                    align: "center",
                    slot: "slot1",
                    width: 200,
                },
                {
                    title: '权限（列表权限）',
                    align: "center",
                    slot: "slot2",
                    width: 200,
                },
                {
                    title: '邮件模板配置',
                    align: "center",
                    slot: "slot4",
                    width: 423,
                },
                {
                    title: '操作',
                    align: "center",
                    slot: "delete",
                    width: 230,
                }
            ],
            dataTable:[],
            addPop:false,
            addItem:{
                chName:'',
                enName:'',
                userOrganizationFlag:''
            },
            visualPop:false,
            transferType:'',
            transferData:[],
            emailItem:{
                receivedRoleGroup:'',
                carbonCopyList:[],
                beAutoSend:'',
                beFileSend:'',
                mailSubject:'',
                mailContent:'',
            },
            whereItem:{
                whereValue:''
            },
            SFList:[
                {value:'0',label:'否'},
                {value:'1',label:'是'}
            ],
            userId:'',
            ruleValidate: {
                chName: [
                    { required: true, message: '中文描述不能为空', trigger: 'blur' }
                ],
                enName: [
                    { required: true, message: '英文描述不能为空', trigger: 'blur' }
                ],
                userOrganizationFlag: [
                    { required: true, message: '请输入选择员工范围', trigger: 'blur' }
                ],
            },
            whereRuleValidate:{
                whereValue: [
                    { required: true, message: '条件不能为空', trigger: 'blur' }
                ],
            },
            emailRuleValidate:{
                receivedRoleGroup: [
                    { required: true, message: '收件人能为空', trigger: 'blur' }
                ],
                carbonCopyList: [
                    { required: true,type:'array', message: '抄送人不能为空', trigger: 'change' }
                ],
                beAutoSend: [
                    { required: true, message: '请选择是否自动触发邮件', trigger: 'change' }
                ],
                beFileSend: [
                    { required: true, message: '请选择附件', trigger: 'change' }
                ],
                mailSubject: [
                    { required: true, message: '主题不能为空', trigger: 'blur' }
                ],
                mailContent: [
                    { required: true, message: '内容不能为空', trigger: 'blur' }
                ],
            },
            updataItem:{},
            updatedData:[],
            remindId:'',
            roleList:[],
        }
    },
    created(){
        let userInfo=JSON.parse(sessionStorage.getItem('userInfo'))
        this.userId = userInfo.userId
        this.getData()
    },
    methods:{
        getData(){
            let json={
                remindId:'',
                chName:this.searchItem.chName,
                ...this.pageInfo
            }
            this.loading=true
            axios.post('/remindModule/selectAllRemindData',json).then(res => {
                this.loading=false
                if(res) {
                    this.dataTable=res.data
                    this.totalNum=Number(res.pageInfo.total)
                }
            })
        },
        //打开列表弹窗
        openPop(index,row){
            this.transferType=index
            this.transferTitle=row.chName
            this.remindId=row.remindId
            this.transferData=[]
            this.updatedData=[]
            if(index==1){
                this.visualPop=true
                let json={
                    remindId:row.remindId
                }
                this.spinShow=true
                axios.post('/remindModule/selectRemindColumnKeyData',json).then(res => {
                    this.spinShow=false
                    if(res) {
                        this.transferData = res.map((el) => {
                            return{
                                ...el,
                                key:el.viewKey,
                                label:el.chColumn,
                                type:el.isShow
                            }
                        })
                        this.updatedData=res.filter(item => item.isShow=='1').map(el => {
                            return{
                                remindId:this.remindId,
                                chColumn:el.chColumn,
                                enColumn:el.enColumn,
                                viewKey:el.viewKey,
                                createUserId:this.userId
                            }
                        })
                    }
                })
                axios.post('/remindModule/selectRemindColumnData',json).then(res => {
                    if(res) {
                        this.whereItem.whereValue=res.whereWord
                    }else{
                        this.whereItem.whereValue=''
                    }
                })
            }else if(index==2){
                this.visualPop=true
                let json={
                    remindId:row.remindId
                }
                this.spinShow=true
                axios.post('/remindModule/selectAllRemindRoleData',json).then(res => {
                    this.spinShow=false
                    if(res) {
                        this.transferData = res.map((el) => {
                            return{
                                ...el,
                                key:el.roleId,
                                label:el.roleName,
                                type:el.isShow
                            }
                        })
                        this.updatedData=res.filter(item => item.isShow=='1').map(el => {
                            return{
                                remindId:this.remindId,
                                roleId:el.roleId,
                                createUserId:this.userId
                            }
                        })
                    }
                })
            }else if(index==3){
                this.addItem=row
                this.addPop=true
            }else {
                this.visualPop=true
                this.spinShow=true
                axios.post('/remindMail/selectRemindMailData',{remindId:row.remindId}).then(res => {
                    this.spinShow=false
                    if(res) {
                        this.emailItem=res
                        axios.post('/remindModule/selectAllRemindRoleData',{remindId:''}).then(res => {
                            if(res) {
                                this.roleList=res
                            }
                        })
                    }else{
                        this.emailItem={}
                        this.$refs['emailRuleValidate'].resetFields();
                    }
                })
               
            }
            
        },
        transferChange(item){
            this.updatedData=[]
            this.transferData.forEach(res => {
                if(this.transferType==1){
                    item.forEach(element => {
                        if(res.viewKey==element){
                            this.updatedData.push({remindId:this.remindId,chColumn:res.chColumn,enColumn:res.enColumn,viewKey:res.viewKey,createUserId:this.userId,columnType:res.columnType})
                        }
                    });
                }else if(this.transferType==2) {
                    item.forEach(element => {
                        if(res.roleId==element){
                            this.updatedData.push({remindId:this.remindId,roleId:res.roleId,createUserId:this.userId})
                        }
                    });
                }
               
            })
        },
        //列表弹窗保存
        saveData(){
            if(this.transferType == 1){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                  this.saveRemindColumnData()
                }
              })
            }else if(this.transferType == 2){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                  this.saveRoleData()
                }
              })
            }else if(this.transferType == 3){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                  this.saveRemindSetData()
                }
              })
            }else {
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                  this.saveMailModel()
                }
              })
            }
        },
        //提醒名单保存
        saveRemindColumnData(){
            this.$refs.whereFormValidate.validate((valid) => {
                if (valid) {
                    this.spinShow=true
                    let json=[
                        {
                            remindId:this.remindId,
                            beWhereFlag:"1",
                            whereWord:this.whereItem.whereValue,
                            createUserId:this.userId
                        }
                    ]
                    this.updatedData=this.updatedData.concat(json)
                    axios.post('/remindModule/insertRemindColumnData',this.updatedData).then(res => {
                        this.spinShow=false
                        if(res) {
                            this.$Message.success('列表配置修改成功');
                            this.visualPop=false
                            this.getData()
                            this.whereItem.whereValue=''
                        }else{
                            this.updatedData.splice(this.updatedData.length-1,1)
                        }
                    })
                }
            })
            
        },
        //权限保存
        saveRoleData(){
            this.spinShow=true
            if(this.updatedData.length==0){
                this.updatedData.push({remindId:this.remindId,roleId:'',createUserId:this.userId})
            }
            axios.post('/remindModule/updateRemindRoleData',this.updatedData).then(res => {
                this.spinShow=false
                if(res) {
                    this.$Message.success('权限修改成功');
                    this.visualPop=false
                    this.getData()
                }
            })
        },
        
        //邮件模板保存
        saveMailModel(){
            this.$refs.emailRuleValidate.validate((valid) => {
                if (valid) {
                    this.spinShow=true
                    let json={
                        ...this.emailItem,
                        remindId:this.remindId,
                        createUserId:this.userId
                    }
                    axios.post('/remindMail/insertRemindMailData',json).then(res => {
                        this.spinShow=false
                        if(res) {
                            this.$Message.success('邮件模板配置成功');
                            this.visualPop=false
                            this.getData()
                            this.$refs.emailRuleValidate.resetFields();
                        }
                    })
                }
            })
            
        },
        //编辑保存
        saveRemindSetData(){
            this.spinShow=true
            axios.post('/remindModule/updateRemindSetData',{...this.addItem,updateUserId:this.userId}).then(res => {
                this.spinShow=false
                if(res) {
                    this.$Message.success('修改成功');
                    this.addPop=false
                     this.$refs.addFormValidate.resetFields();
                    this.getData()
                }
            })
        },
        //新增弹窗
        addData(){
            this.addPop=true
        },
        //新增提醒配置
        addSaveData(){
            this.$Modal.confirm({
              title: this.$notice('sureSave'),
              onOk: () => {
                this.$refs.addFormValidate.validate((valid) => {
                    if (valid) {
                      if(this.transferType==3){
                          this.saveRemindSetData()
                      }else{
                            axios.post('/remindModule/insertData',{...this.addItem,createUserId:this.userId}).then(res => {
                                if(res) {
                                    this.$Message.success('新增成功');
                                    this.addPop=false
                                    this.$refs.addFormValidate.resetFields();
                                    this.getData()
                                }
                            })
                      }
                    }
                }) 
              }
            })
        },
        cancel(){
            this.visualPop=false
            this.whereItem.whereValue=''
            if(this.transferType == 4){
                this.$refs.emailRuleValidate.resetFields();
            }
            
        },
        addCancel(){
            this.addPop=false
            this.addItem={
                chName:'',
                enName:'',
                userOrganizationFlag:''
            }
        },
        opendelete(row){
            this.$Modal.confirm({
                title: row.chName + this.$notice('deletion'),
                content: '',
                onOk: () => {
                    axios.post('/remindModule/deleteRemindDetailInfo',{remindId:row.remindId}).then(res => {
                        if(res) {
                            this.$Message.success('删除成功');
                            this.getData()
                        }
                    })
                }
            });
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
    }
}
</script>

<style lang="scss" scoped>
.btnGroup {
    display: flex;
    justify-content: flex-end;
    align-items: top;
}
.searchRow {
    display:flex;
    justify-content: space-between;
}
@media (max-width: 500px) {
  .searchRow{
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
  }
}
/deep/.ivu-input-group .ivu-input-search {
    background: #8CD29B !important;
    border-color: #8CD29B !important;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/ReminderSetting.vue